import { readMultiNum, readSingleNum } from "../../../utils";
export function readFeatureTableObject(v) {
    // Parse the feature table JSON and assert we got an object
    const featureTableObject = JSON.parse(v.text);
    // Read BATCH_LENGTH
    const instancesLength = readSingleNum(v.data, 2 /* NumType.U32 */, featureTableObject.INSTANCES_LENGTH);
    if (typeof instancesLength === "undefined") {
        throw new Error("Missing INSTANCES_LENGTH semantic in i3dm");
    }
    // Read RTC_CENTER
    let rtcCenter = readMultiNum(v.data, 3, 8 /* NumType.F32 */, featureTableObject.RTC_CENTER);
    if (typeof rtcCenter !== "undefined") {
        rtcCenter = [rtcCenter[0], rtcCenter[1], rtcCenter[2]];
    }
    const eastNorthUp = featureTableObject.EAST_NORTH_UP || false;
    const positions = readMultiNum(v.data, instancesLength * 3, 8 /* NumType.F32 */, featureTableObject.POSITION);
    if (positions === undefined) {
        throw new Error("Missing POSITION semantic in i3dm");
    }
    const normalUp = readMultiNum(v.data, instancesLength * 3, 8 /* NumType.F32 */, featureTableObject.NORMAL_UP);
    const normalRight = readMultiNum(v.data, instancesLength * 3, 8 /* NumType.F32 */, featureTableObject.NORMAL_RIGHT);
    let rotation;
    if (normalUp !== undefined && normalRight !== undefined) {
        rotation = {
            normalUp,
            normalRight,
        };
    }
    else {
        if (normalUp !== undefined || normalRight !== undefined) {
            throw new Error("Both NORMAL_UP or NORMAL_RIGHT is present alone in i3dm");
        }
    }
    const scale = readMultiNum(v.data, instancesLength, 8 /* NumType.F32 */, featureTableObject.NORMAL_UP);
    const scaleNonUniform = readMultiNum(v.data, instancesLength * 3, 8 /* NumType.F32 */, featureTableObject.NORMAL_UP);
    return {
        instancesLength,
        rtcCenter,
        eastNorthUp,
        positions,
        rotation,
        scale,
        scaleNonUniform,
    };
}
// export function readBatchTableObject(_v: { text: string; data: DataView } | undefined): {} | undefined {
//     throw new Error("Unimplemented");
// }
